/// <reference types="vite-plugin-pwa/react" />
import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@organizacaox/lai-design-system";

export function PwaUpdateNotice() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  if (!needRefresh) return null;

  async function update() {
    setPending(true);
    setError(false);
    try {
      await updateServiceWorker(true);
    } catch {
      setError(true);
    } finally {
      setPending(false);
    }
  }

  return (
    <aside
      aria-label="Atualização do aplicativo"
      className="fixed inset-x-3 bottom-24 z-50 mx-auto max-w-md rounded-xl border bg-card p-4 text-card-foreground shadow-lg md:bottom-4 md:left-auto md:right-4"
    >
      <p role="status" className="text-sm font-medium">
        {error
          ? "Não foi possível atualizar. Tente novamente quando estiver conectado."
          : "Uma nova versão do Education está pronta."}
      </p>
      <p className="mt-1 text-sm text-muted-foreground">
        Atualize quando terminar sua aula. A página será recarregada.
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" onClick={() => void update()} disabled={pending}>
          {pending ? "Atualizando…" : "Atualizar agora"}
        </Button>
        <Button size="sm" variant="outline" onClick={() => setNeedRefresh(false)}>
          Depois
        </Button>
      </div>
    </aside>
  );
}
